import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createBlock as _createBlock, resolveDirective as _resolveDirective, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "col-12 col-lg-6 pe-lg-2 form-group" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { for: "referral-address-line-2" }, [
  /*#__PURE__*/_createTextVNode(" Country "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_4 = { class: "col-12 col-lg-6 pe-lg-2 form-group" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "referral-address-line-1" }, [
  /*#__PURE__*/_createTextVNode(" Address Line 1 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_6 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_7 = { class: "col-12 col-lg-6 pe-lg-2 form-group" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "referral-address-line-2" }, " Address Line 2 ", -1 /* HOISTED */)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_10 = { class: "col-12 col-lg-4 pe-lg-2 form-group" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "referral-city" }, [
  /*#__PURE__*/_createTextVNode(" City/Town "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_14 = { class: "col-12 col-lg-4 pe-lg-2 form-group" }
const _hoisted_15 = { for: "referral-state" }
const _hoisted_16 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 2,
  class: "field-invalid"
}
const _hoisted_19 = { class: "col-12 col-lg-4 pe-lg-2 form-group" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "referral-zip" }, [
  /*#__PURE__*/_createTextVNode(" Postal Code "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_21 = ["value", "disabled"]
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 2,
  class: "field-invalid"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CountryTypeahead = _resolveComponent("CountryTypeahead")!
  const _component_PlacesAutocomplete = _resolveComponent("PlacesAutocomplete")!
  const _component_StateTypeahead = _resolveComponent("StateTypeahead")!
  const _directive_number_only = _resolveDirective("number-only")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" INFO: Do not use with.bind when using <slot>. Slot does not render. "),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_CountryTypeahead, {
        "selected-country-prop": _ctx.selectedCountry,
        updateSelectedCountry: _ctx.updateSelectedCountry,
        "prefill-country": _ctx.address.country,
        "onUpdate:prefill-country": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.address.country) = $event)),
        "prefill-country-name": _ctx.autoCompleteCountry,
        "onUpdate:prefill-country-name": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.autoCompleteCountry) = $event)),
        disabled: _ctx.selectedFacility
      }, null, 8 /* PROPS */, ["selected-country-prop", "updateSelectedCountry", "prefill-country", "prefill-country-name", "disabled"])
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createCommentVNode(" Review this component and every prop "),
      _createVNode(_component_PlacesAutocomplete, {
        street: _ctx.address.addressLine1,
        "onUpdate:street": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.address.addressLine1) = $event)),
        city: _ctx.address.city,
        "onUpdate:city": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.address.city) = $event)),
        state: _ctx.address.state,
        "onUpdate:state": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.address.state) = $event)),
        zip: _ctx.address.zipCode,
        "onUpdate:zip": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.address.zipCode) = $event)),
        county: _ctx.address.county,
        "onUpdate:county": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.address.county) = $event)),
        latitude: _ctx.address.latitude,
        "onUpdate:latitude": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.address.latitude) = $event)),
        longitude: _ctx.address.longitude,
        "onUpdate:longitude": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.address.longitude) = $event)),
        disabled: _ctx.selectedFacility,
        "onUpdate:disabled": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedFacility) = $event)),
        country: _ctx.autoCompleteCountry,
        "onUpdate:country": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.autoCompleteCountry) = $event)),
        onBlurredInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.v$.address.addressLine1.$touch())),
        "places-changed-call-back": _ctx.placesChangedCallBack,
        class: _normalizeClass(`${!_ctx.v$.address.addressLine1.$error ? '' : 'field-invalid'}`),
        isValidatedAndByPassToggled: _ctx.address.isValidatedAndByPassToggled,
        "onUpdate:isValidatedAndByPassToggled": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.address.isValidatedAndByPassToggled) = $event))
      }, null, 8 /* PROPS */, ["street", "city", "state", "zip", "county", "latitude", "longitude", "disabled", "country", "places-changed-call-back", "class", "isValidatedAndByPassToggled"]),
      (_ctx.v$.address.addressLine1.$error)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Address Line 1 is required."))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        maxlength: "50",
        type: "text",
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.address.addressLine2) = $event)),
        placeholder: "Enter Address Line 2"
      }, null, 512 /* NEED_PATCH */), [
        [_vModelText, _ctx.address.addressLine2]
      ])
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _withDirectives(_createElementVNode("input", {
        class: _normalizeClass(["form-control", `${!_ctx.v$.address.city.$error ? '' : 'field-invalid'}`]),
        maxlength: "50",
        type: "text",
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.address.city) = $event)),
        placeholder: "Enter City/Town",
        disabled: _ctx.selectedFacility,
        onBlur: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.v$.address.city.$touch && _ctx.v$.address.city.$touch(...args)))
      }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_12), [
        [_vModelText, _ctx.address.city]
      ]),
      (_ctx.v$.address.city.$error)
        ? (_openBlock(), _createElementBlock("span", _hoisted_13, "City/Town is required."))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("label", _hoisted_15, [
        _createTextVNode(_toDisplayString(_ctx.isUnitedStates ? "State" : "State / Province / Territory") + " ", 1 /* TEXT */),
        (_ctx.isUnitedStates)
          ? (_openBlock(), _createElementBlock("span", _hoisted_16, "*"))
          : _createCommentVNode("v-if", true)
      ]),
      (_ctx.isUnitedStates)
        ? (_openBlock(), _createBlock(_component_StateTypeahead, {
            key: 0,
            "selected-state": _ctx.selectedState,
            "onUpdate:selected-state": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.selectedState) = $event)),
            "prefill-state": _ctx.address.state,
            "onUpdate:prefill-state": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.address.state) = $event)),
            disabled: _ctx.selectedFacility,
            onUpdateSelectedState: _ctx.updateSelectedState,
            class: _normalizeClass(`${!_ctx.v$.address.state.$error ? '' : 'field-invalid'}`),
            onBlurredInput: _cache[18] || (_cache[18] = ($event: any) => (_ctx.v$.address.state.$touch()))
          }, null, 8 /* PROPS */, ["selected-state", "prefill-state", "disabled", "onUpdateSelectedState", "class"]))
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            class: _normalizeClass(["form-control", `${!_ctx.v$.address.state.$error ? '' : 'field-invalid'}`]),
            maxlength: "50",
            type: "text",
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.address.state) = $event)),
            placeholder: "Enter State / Province / Territory",
            disabled: _ctx.selectedFacility,
            onBlur: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.v$.address.state.$touch && _ctx.v$.address.state.$touch(...args)))
          }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_17)), [
            [_vModelText, _ctx.address.state]
          ]),
      (_ctx.v$.address.state.$error)
        ? (_openBlock(), _createElementBlock("span", _hoisted_18, "State is required."))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_19, [
      _hoisted_20,
      (_ctx.isUnitedStates)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 0,
            class: _normalizeClass(["form-control", `${!_ctx.v$.address.zipCode.$error ? '' : 'field-invalid'}`]),
            maxlength: "10",
            type: "text",
            value: _ctx.formatZipCode(_ctx.address.zipCode),
            onInput: _cache[21] || (_cache[21] = (e) => _ctx.handleZipcodeChange(e)),
            placeholder: "Enter Zip",
            onBlur: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.v$.address.zipCode.$touch && _ctx.v$.address.zipCode.$touch(...args))),
            disabled: _ctx.selectedFacility
          }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_21)), [
            [_directive_number_only]
          ])
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            class: _normalizeClass(["form-control", `${!_ctx.v$.address.zipCode.$error ? '' : 'field-invalid'}`]),
            maxlength: "9",
            type: "text",
            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.address.zipCode) = $event)),
            placeholder: "Enter Postal Code",
            onBlur: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.v$.address.zipCode.$touch && _ctx.v$.address.zipCode.$touch(...args))),
            disabled: _ctx.selectedFacility
          }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_22)), [
            [_vModelText, _ctx.address.zipCode]
          ]),
      (_ctx.v$.address.zipCode.$error)
        ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Postal Code is required."))
        : _createCommentVNode("v-if", true)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}